// extracted by mini-css-extract-plugin
export var activeHeader = "toc-module--active-header--aU02k";
export var firstLevel = "toc-module--first-level--lhOVJ";
export var otherLevel = "toc-module--other-level--qk1vB";
export var toc = "toc-module--toc--tEDNE";